import { Option } from '@pulse-web-ui/select';

import { PetData } from '@src/store/pets';

export const createKindOptions = (petsData: PetData[]): Option[] =>
  petsData.map(({ kind, kindName }) => ({ label: kindName, value: kind }));
